import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as yup from 'yup';
import { Formik } from 'formik';
import Dialog from '@mui/material/Dialog';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DialogContent from '@mui/material/DialogContent';
import Dropzone from 'react-dropzone';
import Typography from '@mui/material/Typography';
import { closePopup } from '../../actions/uiActions';
import { uploadPresentation } from '../../actions/presentationActions';
import { SeparateFileNameAndExtension } from '../../components/utilities/helperFunctions'
import CloseIcon from '@mui/icons-material/Close';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FolderOpenIcon from '@mui/icons-material/FolderOpen'
import { DatabaseIcon } from '../../images/js/databaseIcon';

class UploadPresentation extends React.Component {
    state = {
        name: "",
        file: null,
        teamIDs: [],
        tagIDs: [],
        customerDatabaseID: null,
        folderID: null
    }

    handleSubmit = (event) => {
        if (event.preventDefault !== undefined) { event.preventDefault(); }
        const data = new FormData();
        if (this.state.name.length > 0) {
            data.append('file', this.state.file, this.state.name);
        } else {
            data.append('file', this.state.file);
        }
        data.append('folderID', this.state.folderID)
        data.append('customerDatabaseID', this.state.customerDatabaseID)
        data.append('teamIDs', this.state.teamIDs)
        data.append('tagIDs', this.state.tagIDs)
        this.props.uploadPresentation(data);
    }

    changeName = (event) => {
        this.setState({ name: event.target.value })
    }

    handleDatabase = (event) => {
        event.preventDefault()
        this.setState({ customerDatabaseID: event.target.value })
    }

    handleFolder = (event) => {
        event.preventDefault()
        this.setState({ folderID: event.target.value })
    }

    fileChangedHandler = (event) => {
        this.setState({ file: event.target.files[0] })
    }

    handleClick = (event) => {
        event.preventDefault();
        this.props.closePopup();
    }

    onDrop(file, values) {
        if (file.length > 0) {
            let fileType = file[0]["type"];
            if (fileType === "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
            fileType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                let uploadedFileName = file[0]["name"]
                let fileName = SeparateFileNameAndExtension(uploadedFileName)["name"]
                let currentFileName = (this.state.name !== "") ? this.state.name : fileName
    
                values["name"] = fileName
    
                this.setState({
                    file: file[0],
                    name: currentFileName
                });
            }
            else {
                this.props.showMessage("File Extension was not .PPTX or .XLSX, Please Try Again", false)
            }
        } else {
            this.props.showMessage("File Extension was not .PPTX or .XLSX, Please Try Again", false)
        }
    }

    handleTeamCheckBoxes = (event) => {
        let ind = this.state.teamIDs.findIndex(x => x === parseInt(event.target.value))
        let arr = this.state.teamIDs
        if (ind !== -1) {
            arr.splice(ind, 1)
        } else {
            arr.push(parseInt(event.target.value))
        }
        this.setState({ teamIDs: arr })
    }

    handleTagCheckBoxes = (event) => {
        let ind = this.state.tagIDs.findIndex(x => x === parseInt(event.target.value))
        let arr = this.state.tagIDs
        if (ind !== -1) {
            arr.splice(ind, 1)
        } else {
            arr.push(parseInt(event.target.value))
        }
        this.setState({ tagIDs: arr })
    }

    populateTeamCheckBoxes = () => {
        if (this.props.customerID !== null) {
            let teams = this.props.teamList.filter(x => x.customer.id === this.props.customerID)

            if (this.props.currentRole === "Builder" || this.props.currentRole === "Viewer") {
                let filteredTeams = []

                for (let allTeamIndex = 0; allTeamIndex< teams.length; allTeamIndex++) {
                    for (let userTeamIndex = 0; userTeamIndex < this.props.currentUser.applicationUserTeams.length; userTeamIndex++) {
                        if (teams[allTeamIndex]["id"] === this.props.currentUser.applicationUserTeams[userTeamIndex]["teamID"]) {
                            filteredTeams.push(teams[allTeamIndex])
                        }
                    }
                }

                teams = filteredTeams
            }

            return (<>
                {teams.map(x => (
                    <li key={`teams-${x.id}`}>
                        <input
                            key={x.id}
                            type="checkbox"
                            defaultChecked={
                                this.state.teamIDs.find((y) => y === x.id) !== undefined
                            }
                            value={x.id}
                            onChange={this.handleTeamCheckBoxes}
                        />
                        &nbsp;&nbsp;
                        {x.name}
                    </li>

                ))}
            </>)
        }
        return (<div style={{ align: "center", height: "40px" }} />)
    }

    populateTagCheckBoxes = () => {
        if (this.props.tagsList !== null) {
            let tags = this.props.tagsList
            return (<>
                {tags.map(x => (
                    <li key={`teams-${x.id}`}>
                        <input
                            key={x.id}
                            onChange={this.handleTagCheckBoxes}
                            type="checkbox"
                            defaultChecked={
                                this.state.tagIDs.find((y) => y === x.id) !== undefined
                                    ? true
                                    : null
                            }
                            value={x.id}
                        />
                        &nbsp;&nbsp;
                        {x.displayName}
                    </li>
                ))}
            </>)
        }
        return (<div style={{ align: "center", height: "40px" }} />)
    }

    populateDatabases = () => {
        if (this.props.dbList) {
            return (
                <Select
                    className="myInput"
                    onChange={this.handleDatabase}
                    defaultValue=''
                    displayEmpty
                    required
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value="">Select Database (optional)</MenuItem>
                    <MenuItem value="-1">Select Multiple Databases (edit after upload)</MenuItem>
                    { this.props.dbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}

                </Select>
            )
        } else {
            return (<div />)
        }
    }

    populateFolders = () => {
        if (this.props.folderList) {
            return (
                <Select
                    className="myInput"
                    onChange={this.handleFolder}
                    defaultValue=''
                    displayEmpty
                    required
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value="">Select Folder</MenuItem>

                    { this.props.folderList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.folderName}</MenuItem>)}

                </Select>
            )
        } else {
            return (<div />)
        }
    }

    render() {
        return (<Dialog
            open={true}
            onClose={this.handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >      <CloseIcon onClick={this.handleClick} className="closePoup" />
                <DialogContent id="alert-dialog-description" className="uploadPOP">
                    <Formik
                        initialValues={{
                            name: ''
                        }}
                        onSubmit={this.handleSubmit}
                        validationSchema={yup.object().shape({ name: yup.string().required('Required') })}
                    >
                        {({
                            values,
                            handleChange,
                            errors,
                            setFieldTouched,
                            touched,
                            handleSubmit
                        }) => (
                            <form>
                                <div className="passwordResetbox">
                                    <div className="uploadOut">
                                    <Dropzone onDrop={(file) => {
                                        this.onDrop(file, values)
                                    }}>
                                        {({getRootProps, getInputProps}) => (
                                            (this.state.file !== null) ? 
                                            (<div id="dropzone" {...getRootProps()}>
                                                <h5>Current File: {this.state.file.name}</h5>
                                                <input {...getInputProps()} />
                                            </div>) : 
                                            (<div id="dropzone" {...getRootProps()}>
                                                <h5>Drop or Click Here to Upload File</h5>
                                                <input {...getInputProps()} />
                                            </div>)
                                        )}
                                    </Dropzone>
                                    <AddPhotoAlternateIcon />
                                    </div>
                                    <div className="adminSelectbox">
                                        <div className="myInputOut">
                                            <input
                                                type="text"
                                                className="myInput"
                                                placeholder="Name"
                                                name="name"
                                                value={values.name}
                                                onChange={handleChange('name')}
                                                onBlur={() => setFieldTouched('name')}
                                                onChangeCapture={this.changeName}
                                        />
                                        {errors.name && touched.name && (
                                            <Typography style={{ fontSize: 15, color: 'red' }}>
                                                {errors.name}
                                            </Typography>
                                        )}
                                    </div>

                                    <div className="myInputOut">
                                        <FolderOpenIcon style={{ display: "block", float: "left", paddingTop: "10px" }} /><div style={{ float: "right", width: "90%" }}> {this.populateFolders()} </div>
                                    </div>
                                    <br /><div>&nbsp;</div>
                                    <div className="myInputOut">
                                        <DatabaseIcon style={{ display: "block", float: "left", paddingTop: "10px" }} /> <div style={{ float: "right", width: "90%" }}> {this.populateDatabases()} </div>
                                    </div>
                                    <br /><br />
                                
                                        <div className="checkOut">
                                            <label className="checkHead">Teams:</label>
                                            <ul>
                                                {this.populateTeamCheckBoxes()}
                                            </ul>
                                        </div>
                                        <div className="checkOut">
                                            <label className="checkHead">Tags:</label>
                                            <ul>
                                                {this.populateTagCheckBoxes()}
                                            </ul>
                                        </div>
                                    </div>
                                    <div>
                                        <button
                                            type="submit"
                                            className="btn"
                                            onClick={(e) => handleSubmit(e)}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Formik>
                </DialogContent>
        </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        teamList: state.users.teamList,
        customerID: state.users.customerID,
        tagsList: state.presentations.present.tagsList,
        dbList: state.users.custDBList,
        folderList: state.users.custFolderList,
        currentUser: state.users.currentUser,
        currentRole: state.users.role
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, uploadPresentation }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadPresentation)